/* eslint-disable no-restricted-imports */
import { useState } from 'react';
import { useIsSomeDialogOpen } from '../../../../routing/ModalRoute';
import { getWindow } from '../../../../utils/getWindow';
import { ONBOARDING_STORAGE_KEY } from '../constants';

export const useIsVisible = () => {
    const isShowedInitial = getWindow()?.localStorage.getItem(ONBOARDING_STORAGE_KEY);
    const [isShowed, setIsShowed] = useState(Boolean(isShowedInitial));
    const isDialogOpen = useIsSomeDialogOpen();

    const isVisible = !isShowed && !isDialogOpen;

    const onClose = () => {
        localStorage.setItem(ONBOARDING_STORAGE_KEY, '1');
        setIsShowed(true);
    };

    return { onClose, isVisible };
};
